<ExpandablePanel 
  title="Registros a bajar"
  description="Esta es la lista de registros que serán bajados por el conector"
  bind:expanded={expanded}>

  <div slot="resume">
    <Text nm color="body">
      Registros a bajar. Hay <b>{actions && actions.length}</b> formularios.       
    </Text>
  </div>

  <div slot="content">
    <br/>
    {#each sortedActions as action}
      <Panel line="fit" mb="xs"
        bg="surface"
        flex items="center"
        rounded="xs"
        py="sm"
        pr="nm" pl="xs"
        >
        <Label
          on:click={() => dispatch("selected", { id: action.id })}
          nm
          py="sm"
          px="sm"
          color="primary"
          rounded="sm"
          pointer
          hover
          >{action.title}
        </Label> 

        <DeleteButton
          on:click={() => dispatch("delete", { id: action.id })}
          rounded="sm" color="body" bg="surface"
          />
      </Panel>
    {/each}
  </div>

</ExpandablePanel>


<script>
  import { createEventDispatcher } from 'svelte';
  import { Panel, Input, Select, Heading, Label, Text, Button, Icon } from 'svelte-stylo';
  import DeleteButton from '@/components/buttons/DeleteButton.svelte';
  import ExpandablePanel from '@/components/panels/ExpandablePanel.svelte'

  export let actions = [];
 
  let expanded = true;

  const dispatch = createEventDispatcher();

  $: sortedActions = actions.sort((a, b) => {
    return a.title.localeCompare(b.title);
  })

</script>